import { Theme } from "@amx/ux-twoui-theming";
import { concatStyleSets, IButtonStyles, IsFocusVisibleClassName } from "@fluentui/react";

export const getButtonStyles = (): IButtonStyles => {
    return {
        root: {
            height: "unset",
            minHeight: "32px"
        },
        textContainer: {
            padding: "6px 0"
        },
        label: {
            lineHeight: "normal"
        }
    };
};

export const getErrorButtonStyles = (theme: Theme): IButtonStyles => {
    const baseStyles = getButtonStyles();

    return concatStyleSets(baseStyles, {
        root: {
            borderColor: theme.palette.redDark,
            color: theme.palette.redDark,
            selectors: {
                [`.${IsFocusVisibleClassName} &:focus`]: {
                    selectors: {
                        ":after": {
                            border: `none`,
                            outlineColor: theme.palette.themeDark,
                        },
                    },
                }
            }
        }
    });
};

export const getAltButtonStyles = (theme: Theme): IButtonStyles => {
    const baseStyles = getButtonStyles();

    return concatStyleSets(baseStyles, {
        root: {
            backgroundColor: theme.palette.transparent,
            borderColor: theme.palette.themeDarkAlt,
            color: theme.palette.themeDarkAlt,
            selectors: {
                [`.${IsFocusVisibleClassName} &:focus`]: {
                    selectors: {
                        ":after": {
                            border: `none`,
                            outlineColor: theme.palette.themeDark,
                        },
                    },
                }
            }
        },
        rootHovered: {
            backgroundColor: theme.palette.transparent,
            borderColor: theme.palette.themeDark,
            color: theme.palette.themeDark
        },
        rootPressed: {
            backgroundColor: theme.palette.transparent,
            borderColor: theme.palette.themeDarker,
            color: theme.palette.themeDarker
        },
        rootDisabled: {
            backgroundColor: theme.palette.transparent,
            borderColor: theme.palette.neutralTertiary,
            color: theme.palette.neutralTertiary
        }
    });
};
